

import {Component, Prop, Vue} from "vue-property-decorator";
import {
  currentUserModule,
  dataFieldsEditModule,
  queryModule,
  studyDefinitionModule,
  studyModule,
  studyPatientModule
} from "@/store";
import DataFields from "@/components/study/DataFields.vue";
import {convertToUpdateDtos} from "@/auxillary/datafield.cache.helpers";
import {MdbsCore} from "@/api/tsclient";
import Rights = MdbsCore.Rights;
import {canSeePatientQueries} from "@/components/query/QueryPermissions";
import DataFieldsChangedDialog from "@/components/study/dataFieldChange/DataFieldsChangedDialog.vue";
import {fieldsWithValuesWillBeChanged, IDataFieldChangeReport} from "@/auxillary/datafield.changes";

@Component({
  components: {DataFieldsChangedDialog, DataFields}
})
export default class PatientEditView extends Vue {
  // Todo: not working properly
  @Prop({default: ""}) private patientId: string;

  private saving: boolean = false;
  private snackbarText = "";
  private showSnackbar = false;
  private snackbarColor = "success";

  showChangeDialog = false;
  changedFields: Array<IDataFieldChangeReport> = [];

  get loading() {
    return studyPatientModule.isLoading ||
        studyModule.isLoading ||
        studyDefinitionModule.isLoading ||
        dataFieldsEditModule.isLoading;
  }

  get canNotEdit() {
    return !currentUserModule.hasRight(Rights.StudyPatientUpdateCmd)
  }

  get patient() {
    return studyPatientModule.studyPatient;
  }

  get instituteDisplayName() {
    return studyPatientModule.studyPatient?.studyInstitute?.displayName ?? "";
  }

  get isValid() {
    // TODO Demo Hack
    // basic check for required field
    return dataFieldsEditModule.dataFields.every(
        d => !d.isVisible || d.values.value != null
    )
  }

  async mounted() {
    // preselect a institute
    await studyPatientModule.loadById(this.patientId)
    await studyModule.loadById(studyPatientModule.studyPatient.studyId ?? "")
    await studyDefinitionModule.loadById(studyModule.study?.studyDefinitionId ?? "")
    dataFieldsEditModule.setEditable(!this.canNotEdit);
    await dataFieldsEditModule.loadDataFields({
      definitions: studyDefinitionModule.studyDefinition.patient?.fields ?? [],
      dataFields: studyPatientModule.studyPatient.fields ?? [],
      validationMessages: studyPatientModule.studyPatient?.validationMessages
    })
    if (this.patientId != undefined && canSeePatientQueries())
      await queryModule.loadQueriesForFields({referenceType: "PatientDefinition", referenceId: this.patientId});
  }

  async cancel() {
    await this.$router.back();
  }

  async checkForFieldChangeBeforeSave() {
    const changedFields = fieldsWithValuesWillBeChanged(dataFieldsEditModule.dataFields);
    if (changedFields.length > 0) {
      this.showChangeDialog = true;
      this.changedFields = changedFields;
    } else {
      await this.saveAfterChangeCheck();
    }
  }

  async saveAfterChangeCheck() {
    this.showChangeDialog = false;
    await this.save();
  }


  async save() {

    this.saving = true

    const studyId = studyModule.study.id
    const fields = convertToUpdateDtos(dataFieldsEditModule.dataFields)

    await studyPatientModule.update({
      id: this.patient.id,
      studyId,
      instituteId: this.patient.studyInstitute?.id,
      displayName: this.patient.displayName,
      lockedManually: this.patient.lockedManually,
      identifier: this.patient.identifier,
      fields
    })

    dataFieldsEditModule.setValidationMessages(studyPatientModule.studyPatient?.validationMessages ?? []);

    if (studyPatientModule.studyPatient.canSave) {
      this.showUpdateSucceededSnackBar()
      await this.$router.back();
    }

    this.showUpdateFailedSnackBar();
    this.saving = false
  }

  showUpdateSucceededSnackBar() {
    this.snackbarColor = "success";
    this.snackbarText = "Alle Änderungen wurden gespeichert."
    this.showSnackbar = true;
  }

  showUpdateFailedSnackBar() {
    if (studyPatientModule.studyPatient?.validationMessages?.some(v => v.messageType == "error"))
      this.snackbarColor = "error";
    else
      this.snackbarColor = "warning";
    this.snackbarText = "Invalide Daten, Änderungen konnten nicht gespeichert werden."
    this.showSnackbar = true;
  }
}
